import Vue from 'vue';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import '@/assets/styles/main.sass';
import vueHeadful from 'vue-headful';
import i18n from '@/i18n';
import { default as importGlobalComponents } from '@/import-global-components';

Vue.config.productionTip = false;
importGlobalComponents();
Vue.component('vue-headful', vueHeadful);

new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
